import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

export function getInitials(name) {
  if (!name) return '?';
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function getStatusColor(status) {
  const colors = {
    pending: 'badge-warning',
    accepted: 'badge-success',
    declined: 'badge-error',
    cancelled: 'badge-error',
    completed: 'badge-primary',
    draft: 'badge-warning',
    submitted: 'badge-warning',
    approved: 'badge-success',
    rejected: 'badge-error',
    open: 'badge-warning',
    under_review: 'badge-warning',
    resolved: 'badge-success',
    closed: 'badge-primary',
  };
  return colors[status] || 'badge-primary';
}

export function getListingTypeLabel(type) {
  const labels = {
    stall: 'Stall',
    pasture: 'Pasture',
    layover: 'Layover',
    full_boarding: 'Full Boarding',
  };
  return labels[type] || type;
}

export function truncateText(text, maxLength = 100) {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
}

export function calculateNights(checkIn, checkOut) {
  const start = new Date(checkIn);
  const end = new Date(checkOut);
  const diff = end - start;
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}
